/**
 * Keyboard activation for elements that are clickable but aren't native
 * buttons or links.
 *
 * A `<div onClick>` is invisible to keyboard and switch users: it can't be
 * focused, and Enter/Space do nothing. Product cards, cart rows and category
 * items across the shop were built this way, so the entire catalogue was
 * mouse-only. Pairing this with `role="button"` and `tabIndex={0}` restores
 * the behaviour a native button would have given for free.
 *
 * Space is preventDefault'd because its default action scrolls the page.
 *
 *   <div
 *     role="button"
 *     tabIndex={0}
 *     onClick={open}
 *     onKeyDown={activateOnKey(open)}
 *   />
 *
 * Prefer a real <button> or <Link> when the markup allows it — this exists for
 * the cases where the clickable region already wraps other content.
 */
export const activateOnKey = (handler) => (event) => {
  if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
    event.preventDefault();
    handler(event);
  }
};

export default activateOnKey;
